<h1>{{ 'text_aiBuilder__wrong' | dbText }}</h1>

<p *ngIf="!canRetry">{{ 'text_weEncounteredAnError' | dbText }} <a (click)="openChat()">{{ 'text_customerCare' | dbText }}</a>
    {{ 'text_teamIfYouNeedFurtherAssistance' | dbText}}</p>
<p *ngIf="canRetry">{{ 'text_weEncounteredAnErrorWhileGenerating' | dbText }}</p>

@if (canRetry) {
    <button class="ds-btn-blue rectangle" (click)="retry()">
        <span>{{ 'text_retry' | dbText }}</span>
    </button>
}

